export { default } from "./useRemoveSchoolQueryParam";
